import { AppHolder } from '@/utils/app-holder'

export default function () {
  // ALWAYS 'me' in Conseil since you can only view your own data
  // Is used to display other user's data in Advisory
  let user = 'me'

  if (AppHolder.store.state.advisor.authenticated) {
    if (AppHolder.store.state.user.profile) {
      user = AppHolder.store.state.user.profile.id
    }
  }

  return user
}
